import * as THREE from 'three';

import IndexedBufferGeometryAdapter from './IndexedBufferGeometryAdapter';
import UnIndexedBufferGeometryAdapter from './UnIndexedBufferGeometryAdapter';
import GeometryAdapter, { FaceIndices, FaceVertices } from './GeometryAdapter';

export interface GeometryAdapterInterface {
  vertices: THREE.Vector3[];
  numVertices: number;
  numFaces: number;
  similarVertex: number[][];
  setVertex(index: number, x: number, y: number, z: number): void;
  setVertexX(index: number, x: number): void;
  setVertexY(index: number, y: number): void;
  setVertexZ(index: number, z: number): void;
  getVertex(index: number): THREE.Vector3;
  getVertexX(index: number): number;
  getVertexY(index: number): number;
  getVertexZ(index: number): number;
  getNormal(index: number): THREE.Vector3;
  getFace(index: number): FaceIndices;
  getFaceVertices(index: number): FaceVertices;
  updateVertices(): void;
  updateFaces(): void;
  getBoundingBox(): THREE.Box3 | null;
}

export const calculateSimilarVertexForAdapter = (adapter: GeometryAdapterInterface): void => {
  adapter.similarVertex = [...Array(adapter.numVertices)].map(() => []);
  const vertexList = adapter.vertices.map((item, index) => {
    return {
      index: index,
      item: item,
    };
  });
  for (let i = 0; i < adapter.numVertices; i++) {
    if (adapter.similarVertex[i].length > 0) continue;
    const vertex = adapter.getVertex(i);
    const indexList = vertexList.filter((item) => item.item.x === vertex.x && item.item.y === vertex.y && item.item.z === vertex.z).map((item) => item.index);
    for (const index of indexList) {
      adapter.similarVertex[index] = indexList.filter((item) => item !== index);
    }
  }
};

export default class GeometryAdapterFactory {
  getAdapter(geometry: THREE.BufferGeometry, calculateSimilarVertex = false): GeometryAdapterInterface {
    const hasPositionAttr = geometry.attributes && geometry.attributes.position;

    if (hasPositionAttr) {
      if (geometry.index) {
        return new IndexedBufferGeometryAdapter(geometry, calculateSimilarVertex);
      } else {
        return new UnIndexedBufferGeometryAdapter(geometry, calculateSimilarVertex);
      }
    } else {
      return new GeometryAdapter(geometry, calculateSimilarVertex);
    }
  }
}
